import React from 'react';
import { Form, FormControl } from 'react-bootstrap';
import Pagination from 'react-js-pagination';


const Paginator = (props) => {
  const {
    itemsPerPage, activePage, setFilters, totalItemsCount,
  } = props;
  return (
    <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
      <Form.Group style={{ width: '50px' }} controlId="formGridState">
        <FormControl
          style={{ height: 28, width: 'auto', padding: '0 0' }}
          value={itemsPerPage}
          as="select"
          onChange={({ target: { value } }) => {
					  setFilters(value, 1);
          }}
        >
          <option key="" value="20">20</option>
          <option key="1" value="50">50</option>
          <option key="2" value="100">100</option>
        </FormControl>
      </Form.Group>
      <Pagination
        activePage={activePage}
        itemsCountPerPage={parseInt(itemsPerPage, 10)}
        totalItemsCount={totalItemsCount || 0}
        pageRangeDisplayed={5}
        onChange={(event) => {
				  setFilters(itemsPerPage, event);
        }}
      />
    </div>
  );
};
export default Paginator;
